module.exports = __webpack_public_path__ + "img/deleteGrey.79c9928b.svg";